import type { VoidFunctionComponent } from 'react';

import Loader from '../../../../generic/Loader';
import type { Dependency } from '../../../../../../shared/dependenciesV2';
import type { NoticeMatch } from '../../../../../../shared/types/routes/revisions';

import { NoticeFileItemContainer } from './NoticeFileItemContainer';

import styles from '../DependencyDrawer.module.less';

const noNoticesState = (
  <div className={styles.noNotices}>
    FOSSA does not currently have any NOTICE file data for this dependency.
  </div>
);

type DependencyNoticesProps = {
  dependency: Dependency;
  notices?: NoticeMatch[];
  isLoading?: boolean;
  isError?: boolean;
};

export const DependencyNoticeContainer: VoidFunctionComponent<DependencyNoticesProps> = ({
  dependency,
  notices,
  isLoading,
  isError,
}) => {
  if (isError) {
    return null;
  }

  return (
    <>
      <div className={styles.header}>
        NOTICE Files
      </div>
      {isLoading ? <Loader /> : (
        <div className={styles.notices}>
          {!notices?.length ? noNoticesState : (
            <div className={styles.notices}>
              {notices.map((notice) => (
                <NoticeFileItemContainer
                  dependencyRevisionLocator={dependency.locator}
                  key={notice.id.toString()}
                  notice={notice}
              />
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};
